// actions.js
export const FETCH_DAILY_REPORTS_REQUEST = 'FETCH_DAILY_REPORTS_REQUEST';
export const FETCH_DAILY_REPORT_REQUEST = 'FETCH_DAILY_REPORT_REQUEST';
export const FETCH_REPORT_TECHNICIAN_REQUEST = 'FETCH_REPORT_TECHNICIAN_REQUEST';
export const FETCH_REPORT_STATUS_REQUEST = 'FETCH_REPORT_STATUS_REQUEST';

export const FETCH_DAILY_REPORTS_SUCCESS = 'FETCH_DAILY_REPORTS_SUCCESS';
export const FETCH_DAILY_REPORT_SUCCESS = 'FETCH_DAILY_REPORT_SUCCESS';
export const FETCH_REPORT_TECHNICIAN_SUCCESS = 'FETCH_REPORT_TECHNICIAN_SUCCESS';
export const FETCH_REPORT_STATUS_SUCCESS = 'FETCH_REPORT_STATUS_SUCCESS';

export const FETCH_DAILY_REPORTS_FAILURE = 'FETCH_DAILY_REPORTS_FAILURE';
export const FETCH_DAILY_REPORT_FAILURE = 'FETCH_DAILY_REPORT_FAILURE';
export const FETCH_REPORT_TECHNICIAN_FAILURE = 'FETCH_REPORT_TECHNICIAN_FAILURE';
export const FETCH_REPORT_STATUS_FAILURE = 'FETCH_REPORT_STATUS_FAILURE';

export const fetchDailyReportsRequest = (data) => ({ type: FETCH_DAILY_REPORTS_REQUEST, payload: data });
export const fetchDailyReportRequest = (data) => ({ type: FETCH_DAILY_REPORT_REQUEST, payload: data });
export const fetchReportTechnicianRequest = (data) => ({ type: FETCH_REPORT_TECHNICIAN_REQUEST, payload: data });
export const fetchReportStatusRequest = (data) => ({ type: FETCH_REPORT_STATUS_REQUEST, payload: data });

export const fetchDailyReportsSuccess = (data) => ({ type: FETCH_DAILY_REPORTS_SUCCESS, payload: data });
export const fetchDailyReportSuccess = (data) => ({ type: FETCH_DAILY_REPORT_SUCCESS, payload: data });
export const fetchReportTechnicianSuccess = (data) => ({ type: FETCH_REPORT_TECHNICIAN_SUCCESS, payload: data });
export const fetchReportStatusSuccess = (data) => ({ type: FETCH_REPORT_STATUS_SUCCESS, payload: data });

export const fetchDailyReportsFailure = (error) => ({ type: FETCH_DAILY_REPORTS_FAILURE, payload: error });
export const fetchDailyReportFailure = (error) => ({ type: FETCH_DAILY_REPORT_FAILURE, payload: error });
export const fetchReportTechnicianFailure = (error) => ({ type: FETCH_REPORT_TECHNICIAN_FAILURE, payload: error });
export const fetchReportStatusFailure = (error) => ({ type: FETCH_REPORT_STATUS_FAILURE, payload: error });